import { all } from 'redux-saga/effects'
import { app } from './app'
import { session } from './session'
import { version } from './version'

export const sagas = function* () {
  yield all([app(), session(), version()])
}
